import { Providers } from "@/app/providers";
import AppRouter from "@/app/router";
import { AppToaster } from "@/app/AppToaster";
import { ErrorFallback } from "@/app/error-boundaries/ErrorFallback";
import { LoadingScreen } from "@/app/fallbacks/LoadingScreen";
import { queryClient } from "@/infrastructure/query/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Suspense } from "react";
import { ErrorBoundary } from "@sentry/react";

export default function App() {
  return (
    <ErrorBoundary fallback={ErrorFallback} showDialog={false}>
      <QueryClientProvider client={queryClient}>
        <Providers>
          <Suspense fallback={<LoadingScreen />}>
            <AppRouter />
          </Suspense>
          <AppToaster />
        </Providers>
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
